// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__hJTpC","layout__title":"styles_layout__title__e3HH3"};